import React, { useState } from 'react';
import {motion} from 'framer-motion';
import {useGlobalContext} from '../../Utils/ContextApi'
import {navlinks} from '../Navbar/navlinks'
import { Link } from 'react-router-dom';
import{ FaFacebook, FaTimes, FaTwitter, FaLinkedin} from 'react-icons/fa';
import './sidebar.css'

function Sidebar() {
    const {isSidebarOpen, closeSidebar} = useGlobalContext()
   
  return (
    <motion.aside className={`${isSidebarOpen ? 'overlay show-modal' : 'overlay'}`}>
      <div className='wrapper'>
      <div className="sidebar-heading">
        <Link to='/home' style={{textDecoration:"none", color:'#fff', fontWeight:"bolder"}}><span style={{color:"gold"}}>Fo</span>Movie</Link>
      <FaTimes  onClick={closeSidebar} className="modal-btn" />
      </div>
        {navlinks.map((link, index)=>{
          const {name, url, icon} = link;
          return(
            <Link key={index} to={url} onClick={closeSidebar} className='nav-link2'>
              {name} {icon}
            </Link>
          )
        })}
        <div className='social-icons'>
          <FaFacebook />
          <FaTwitter />
          <FaLinkedin />
        </div>
        </div>
        </motion.aside>
  )
}

export default Sidebar